/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, days: NonNullable<unknown>, plan: NonNullable<unknown> }} Report_MetaInputs */



/**
* | output |
* | --- |
* | "{range} · {days} days · {plan} plan" |
*
* @param {Report_MetaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_meta = /** @type {((inputs: Report_MetaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_MetaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.range} · ${i?.days} Tage · Tarif ${i?.plan}`)
	return /** @type {LocalizedString} */ (`${i?.range} · ${i?.days} days · ${i?.plan} plan`)
});